module.exports = __webpack_public_path__ + "img/grails.0cb24d84.svg";